import router from "@/router";
import store from "@/store/store";

const DialogModule = {
  namespaced: true,
  state: {
    dialog: {
      title: "Error",
      icon: "cil-speech",
      message: "asdsadsad",
      code:"20000",
      color:"danger",
      number :"1",
      status:false,
      // actions: [
      //   { label: 'ลบถาวร', code: 'permanent-delete', icon: 'cil-trash' },
      //   { label: 'ย้ายไปถังขยะ', code: 'soft-delete', icon: 'cil-inbox' }
      // ]
    },
    isCode : null,
    loading:false,
    message:0,
    toasts:0,
    toastM:"",

  },

  mutations: {
    toasts(state, data) {
      state.toasts = data
    },
    toastM(state, data) {
      state.toastM = data
    },

    loading(state, data) {
      state.loading = data
    },

    message(state, data) {
      state.message = data
    },

    dialog(state, data) {
      state.dialog = data
    },
    isCode(state, data) {
      state.isCode = data
    }
  },

  actions: {

  },

  getters: {
    toasts(state) {
      return state.toasts
    },
    toastM(state) {
      return state.toastM
    },
    loading(state) {
      return state.loading
    },

    message(state) {
      return state.message
    },

    dialog(state) {
      return state.dialog
    },

    isCode(state) {
      return state.isCode
    }
  },
};

export default DialogModule;
